export default {"src":"/_next/static/media/kunstrijden.738f0c13.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};